/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  sys-auth.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:33
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
 import {axios, Parameter} from "./index";
export class SysUserDTO {
  userNo!: string;
  /** 账号到期时间 */
  accountExpires?: string;

  /** 头像图片地址 */
  avatar?: string;

  /** 出生年月日 */
  birthday?: string;

  /** 创建人 */
  createUser?: string;

  /** 创建人登录名 */
  createUserName?: string;

  /** 邮箱 */
  email?: string;

  /** 工号 */
  employeeCode?: string;

  /** 员工状态 0试用，1正式，2离职，3开除 */
  employeeStatus?: string;

  /** 性别 F:男，M:女，U:未知 */
  gender?: string;

  /** 创建时间 */
  gmtCreate?: string;

  /** 更新时间 */
  gmtModified?: string;

  /** 身份证号码 */
  idNumber?: string;

  /** 是否删除 1：是，0否 */
  isDelete?: number;

  /** 是否启用 true：是，false: 否 */
  enabled?: boolean;

  /** 是否锁定 1:是，0:否 */
  isLocked?: number;

  /** 锁定时间 */
  lockedTime?: string;

  /** 手机号 */
  mobilePhone?: string;

  /** 更新人 */
  modifiedUser?: string;

  /** 更新人登录名 */
  modifiedUserName?: string;

  /** 昵称 昵称 */
  nickname?: string;

  /** 密码 */
  password?: string;

  /** 密码连续输入错误次数 */
  passwordErrorTimes?: number;

  /** 密码到期时间 */
  passwordExpires?: string;

  /** 密码类型 0:初始化密码，1:自定义密码 */
  passwordType?: string;

  /** 座机号 */
  phone?: string;

  /** 备注 */
  remark?: string;

  /** 租户号 */
  tenantId?: string;

  /** 编号 */
  userId!: string;

  /** 姓名 真实姓名 */
  username!: string;

  /** 登录名 */
  loginName!: string;
}

export class SysTenantDTO {
  /** 租户管理员 */
  adminUser!: SysUserDTO;

  /** 所属域编号 */
  domainId!: string;

  /** 是否启用 1：是，0否 */
  enabled?: boolean;

  /** 备注 */
  remark?: string;

  /** 租户代码 */
  tenantCode?: string;

  /** 租户到期时间 */
  tenantExpires?: string;

  /** 编号 */
  tenantId!: string;

  /** 租户最大用户数 -1为无限制 */
  tenantMaxUser?: number;

  /** 租户名称 */
  tenantName?: string;

  /** userId */
  adminUserId!: string;

  /** 租户LOGO */
  tenantLogo!: string;
}

export class FeiDaiUserDetails {
  /** 账号到期时间 */
  accountExpires?: string;

  /** accountNonExpired */
  accountNonExpired?: boolean;

  /** accountNonLocked */
  accountNonLocked?: boolean;

  /** authorities */
  authorities?: Array<RoleGrantedAuthority>;

  /** 头像图片地址 */
  avatar?: string;

  /** credentialsNonExpired */
  credentialsNonExpired?: boolean;

  /** 是否删除 1：是，0否 */
  delete?: boolean;

  /** 内部工号 */
  employeeId?: string;

  /** 是否启用 1：是，0否 */
  enabled?: boolean;

  /** 是否锁定 1:是，0:否 */
  locked?: boolean;

  /** 锁定时间 */
  lockedTime?: string;

  /** 密码 */
  password?: string;

  /** 密码连续输入错误次数 */
  passwordErrorTimes?: number;

  /** 密码到期时间 */
  passwordExpires?: string;

  /** 密码类型 0:初始化密码，1:自定义密码 */
  passwordType?: string;

  /** 备注 */
  remark?: string;

  /** 租户号 */
  tenantId?: string;

  /** 租户信息 */
  // tenantInfo?: SysTenantDTO;

  /** 编号 */
  userId?: string;

  /** 用户类型 */
  userType?: string;

  /** 登入账号 */
  username?: string;
}

export class SysMenuDTO {
  /** 接口请求方法 */
  apiMethod?: "POST" | "GET" | "PUT" | "DELETE" | "PATCH";

  /** 接口读写模式 r读、w写 */
  apiMode?: string;

  /** children */
  children?: Array<SysMenuDTO>;

  /** 所属系统 */
  clientId?: string | { key: string; label: string };

  /** 所属系统名 */
  clientName?: string;

  /** 是否默认授权 */
  defaultGrant?: boolean;

  /** 是否启用 1：是，0否 */
  enabled?: boolean;

  /** 表单 */
  // grids?: Array<SysGridDTO>;

  /** id */
  id!: string;

  /** 所有父级菜单 */
  levelIds?: string;

  /** 菜单图标 */
  menuIcon?: string;

  /** 编号 */
  menuId!: string;

  /** 菜单名称 */
  menuName!: string;

  /** 菜单类型 */
  menuType!: string;

  /** 菜单地址 */
  menuUrl?: string;

  /** 父级菜单 */
  parentId?: string;

  /** 排序号 */
  priority!: number;

  /** 菜单标识 */
  actionName!: string;

  /** 是否半选 */
  halfChecked!: boolean;

  /** 路由路径 */
  routePath?: string;
}

export class PwdRegExp {
  match!: boolean;
  msg!: string;
  regexp!: RegExp | string;
  type!: string;
}

export interface PwdRegExpPro extends PwdRegExp {
  regexp: RegExp;
}

export class RoleGrantedAuthority {
  /** authority */
  authority?: string;

  /** roleName */
  roleName?: string;
}

// 获取菜单
export function getUserMenus (parameter: Parameter = {}) {
  return axios<Ajax.Response<SysMenuDTO[]>>({
    url: '/sysauth/menus',
    method: 'get',
    params: parameter,
    extraParams: { showLoading: false }
  })
}
